import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { SieniService } from '../../services/sieni.service';
import { MSource } from '../../models/source-taker.model';
import { element } from 'protractor';
import { Source } from '../../interfaces/Organization';
import { TranslateService } from '@ngx-translate/core';
import { Alert } from '../../models/alert.model';

@Component({
  selector: 'taker',
  templateUrl: './taker.component.html',
  styleUrls: ['./taker.component.scss']
})
export class TakerComponent implements OnInit {

  constructor(private _globalService: SieniService, private translate: TranslateService){}

  @Output() public close = new EventEmitter<boolean>();
  @Output() public dismiss = new EventEmitter<string>();
  @Input() public evaluationId: number = null;

  public takers: MSource[] = null;
  public sources: MSource[] = null;
  public name: string = '';
  public type: string = '1';
  public isSetting: boolean = false;

  public onDismiss(text: string){
    this.dismiss.emit(text)
  }

  ngOnInit() {
    this.translate.setDefaultLang("es")
    this._globalService.getSourcesAndTakers(this.evaluationId).subscribe(({data}:any)=>{
      console.log(data)
      this.takers = []
      this.sources = []
      data.forEach(e => {
        if (e.tipo == 1) {
          this.takers.push(new MSource(e))
        } else {
          this.sources.push(new MSource(e))
        }
      });
      // console.log(this.takers)
      // console.log(this.sources)
    })
  }

  public setSourcesAndTakers(){
    let sources: Source[] = []
    this.isSetting = true;
    this.takers.forEach(e=>{
      if (e.active) {
        sources.push({
          id: e.id,
          nombre: e.name,
          tipo: e.type
        })
      }
    })
    this.sources.forEach(e=>{
      if (e.active) {
        sources.push({
          id: e.id,
          nombre: e.name,
          tipo: e.type
        })
      }
    })
    // console.log(sources)
    this._globalService.setSourcesAndTakers(this.evaluationId, sources).subscribe(res=>{
      this.close.emit(true)
    }, err=>{
      this.isSetting = false;
      Alert.buildErrorAlert(this.translate.instant('evaluations.takers.error'))
    })
  }

  public checkValidity(){
    for (let i = 0; i < this.takers.length; i++) {
      if (this.takers[i].active) {
        return false;
      }
    }
    for (let i = 0; i < this.sources.length; i++) {
      if (this.sources[i].active) {
        return false;
      }
    }
    return true;
  }

  public createItem(){
    const item: Source = {
      id: null,
      nombre: this.name,
      tipo: +this.type
    }
    let push: boolean = true;
    if (this.type === '1') {
      for (let i = 0; i < this.takers.length; i++) {
        if (this.takers[i].name.toLocaleLowerCase() === this.name.toLocaleLowerCase()) {
          push = false
          break
        }
      }
      if (push) {
        this.takers.push(new MSource(item))
      } else {
        Alert.buildErrorAlert(this.translate.instant("evaluations.takers.alert.takers"))
      }
    } else {
      for (let i = 0; i < this.sources.length; i++) {
        if (this.sources[i].name.toLocaleLowerCase() === this.name.toLocaleLowerCase()) {
          push = false;
          break
        }
      }
      if (push) {
        this.sources.push(new MSource(item))
      } else {
        Alert.buildErrorAlert(this.translate.instant("evaluations.takers.alert.source"))
      }
    }
    this.name = ''
  }

  public deleteSource(index: number){
    this.sources.splice(index, 1)
  }

  public deleteTaker(index: number){
    this.takers.splice(index, 1)
  }

}
